import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { ExclusivePriceGrid, SaveExclusivePricesRequest } from '@models/exclusive-prices';
import { Observable } from 'rxjs';

/**
 * Whole-lake exclusive pricing (CS-286). Like the combination grids, the grid is exchanged as one
 * document per (water, price list): a single GET loads all season × stay-type cells and a single PUT
 * saves the whole grid, which the API reconciles to minimal writes — cells absent from the payload are
 * deleted. Reads are open; the PUT is rejected with 400 for a water that does not permit exclusive hire.
 */
@Injectable({ providedIn: 'root' })
export class CrmWaterExclusivePricesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/crm/waters`;

  getGrid(waterId: number, priceListId: number): Observable<ExclusivePriceGrid> {
    return this.http.get<ExclusivePriceGrid>(this.gridUrl(waterId, priceListId));
  }

  saveGrid(waterId: number, priceListId: number, request: SaveExclusivePricesRequest): Observable<ExclusivePriceGrid> {
    return this.http.put<ExclusivePriceGrid>(this.gridUrl(waterId, priceListId), request);
  }

  private gridUrl(waterId: number, priceListId: number): string {
    return `${this.baseUrl}/${waterId}/price-lists/${priceListId}/exclusive-prices`;
  }
}
